package com.kinoshazam.uiKit.episodeItem

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsHoveredAsState
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.image.UiKitImage
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.extension.shimmer.shimmer
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.movie
import org.jetbrains.compose.resources.painterResource

data class EpisodeViewDefaults(
    val size: DpSize = DpSize(130.dp, 90.dp),
    val cornerRadius: Dp = 2.dp,
    val borderWidth: Dp = 2.dp,
)

@Composable
fun EpisodeView(
    modifier: Modifier = Modifier,
    title: String = "",
    isSelected: Boolean = false,
    isLoading: Boolean = false,
    defaults: EpisodeViewDefaults = EpisodeViewDefaults(),
    onAction: () -> Unit = {}
) {
    val interactionSource = remember { MutableInteractionSource() }
    val isHovered by interactionSource.collectIsHoveredAsState()
    val highlighted = isHovered || isSelected
    val shape = RoundedCornerShape(defaults.cornerRadius)

    var boxModifier = modifier
        .size(defaults.size)
        .clip(shape)
        .background(UiKitTheme.colors.color_4)
        .clickable(
            interactionSource = interactionSource,
            indication = null,
            onClick = onAction,
        )

    if (isLoading) boxModifier = boxModifier.then(Modifier.shimmer())

    if (highlighted) {
        boxModifier = boxModifier.then(
            Modifier.border(
                BorderStroke(defaults.borderWidth, UiKitTheme.colors.color_1),
                shape,
            )
        )
    }

    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = boxModifier,
    ) {
        UiKitImage(
            state = ImageUiKitState(
                url = "",
                placeholder = painterResource(Res.drawable.movie),
                placeholderColor = if (highlighted) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_3,
                contentScale = ContentScale.Crop,
            ),
        )
        TextLabel(
            state = TextLabelState(
                text = title,
                color = if (isHovered) UiKitTheme.colors.color_1 else UiKitTheme.colors.color_2,
            )
        )
    }
}
